import '../../styles-new/pages/broadcasts-live.scss';
import '../components/war-slider';
import generateTabs from '../components/generateTabs';

generateTabs('sidebar-last', { isLoadMore: false });
document.querySelector('.sidebar-last .load-more').addEventListener('click', function (e) {
  let active_tab = e.target.closest('.sidebar-last').querySelector('.tabs__item_active').dataset.tab || 'all';
  let tab_content = e.target.closest('.sidebar-last').querySelector(`[data-tabdata=${active_tab}]`);
  load_posts('/load-posts/', tab_content, 'list', tab_content.dataset.page, active_tab);
});

window.addEventListener('load', () => {
  let script = document.createElement('script');
  script.src = "https://www.youtube.com/player_api";
  document.body.append(script);
});

window.onYouTubePlayerAPIReady = function () {
  const videoFrameWrapperImage = document.querySelector('.broadcasts_live__video_image');
  if(videoFrameWrapperImage) {
    videoFrameWrapperImage.addEventListener('click', () => {
      const player =  new YT.Player('ytplayer', {
        height: '360',
        width: '640',
        videoId: window.youtubeId,
        events: {
          'onReady': onPlayerReady,
        },
        playerVars: {
          rel: 0,
          color: 'red',
        },
        events: {
          onReady: onPlayerReady,
        },
      });

      function onPlayerReady() {
        videoFrameWrapperImage.classList.add('broadcasts_live__video_image_hidden');
        player.playVideo()
      }
    });
  }
};